import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import BoostProfile from "./BoostProfile";
import BoostAdd from "./BoostAdd";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import { checkProductAdd, checkProfileAdd } from "../../../../Files/AddChecker";

const AddDetail = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [BoostProfileSet, setBoostProfileSet] = useState(false);
  const [BoostAddSet, setBoostAddSet] = useState(false);
  const [addBoosted, setAddBoosted] = useState(true);
  const [profileBoosted, setProfileBoosted] = useState(true);

  const [Product, setProduct] = useState(null);
  const [User, setUser] = useState(null);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const fetchProduct = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/product/getproduct/${id}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      setProduct(response.data);
      setUser(response.data.User);
    } catch (error) {
      showAlert("Error fetching Product", "danger");
    }
  };

  const toggleProductStatus = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const URL = Product?.UserStatus == "Archive" ? "activate" : "archive";
      const response = await axios.put(
        `${BaseURL}/api/product/${URL}/${id}`,
        {},
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      showAlert(`Product moved to ${URL}`, "success");
      fetchProduct();
    } catch (error) {
      showAlert("Error changing product status", "danger");
    }
  };

  const fetchAddBoosted = async () =>{
    const data = await checkProductAdd(id);
    setAddBoosted(data)
    const dataProfile = await checkProfileAdd();
    setProfileBoosted(dataProfile)
  }

  useEffect(() => {
    fetchProduct();
    fetchAddBoosted()
  }, []);

  const createProductBoost =async (planId, requestId)=>{
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.post(
        `${BaseURL}/api/addSystem/addPayment/order-status/${id}/${planId}/${requestId}`,
        { },
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      if(response.status===200 || response.status===202){
        showAlert("Product boosted successfully", "success");
      }
    } catch (error) {
      showAlert("Error boosting product", "danger");
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('requestId') && params.get('planId')) {
      createProductBoost(params.get('planId') , params.get('requestId'))
    }
  }, [location.pathname]);

  return (
    <>
      {BoostProfileSet && (
        <BoostProfile setBoostProfileSet={setBoostProfileSet} />
      )}
      {BoostAddSet && <BoostAdd setBoostAddSet={setBoostAddSet} />}
      <div className="w-[95%] m-auto flex flex-col-reverse lg:flex-row gap-6 py-6">
        <div
          className={`basis-[55%] border-2 border-light  flex flex-col gap-4 rounded-2xl py-4 px-6 overflow-hidden   *: ${theme == "dark" ? "bg-black text-white" : "bg-white "
            } `}
        >
          <div className="flex font-pop flex-row justify-between items-center">
            <h2 className="text-2xl font-semibold">{Product?.Title}</h2>
            <div className="bg-primarygreen/30 font-pop py-1 px-2 rounded-3xl h-fit font-medium text-xl">
              ${Product?.Price}
            </div>
          </div>
          <div className="">
            <Swiper
              navigation={true}
              modules={[Navigation]}
              className="mySwiper"
            >
              {Product?.Images?.map((item, index) => (
                <SwiperSlide>
                  <img
                    src={item.img}
                    alt=""
                    className="w-full h-[50vh] object-cover rounded-2xl"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="flex font-pop flex-col gap-2">
            <h3
              className={`  text-lightGrey text-lg font-medium ${theme == "dark" && "text-white"}`}
            >
              Description
            </h3>
            <p>{Product?.Description}</p>
          </div>
        </div>
        <div className="basis-[30%] flex flex-col gap-2">
          <div className="flex font-pop gap-1 w-full items-center">
            {!addBoosted && <button
              onClick={() => setBoostAddSet(true)}
              className={`m-1 w-max bg-green-500 hover:bg-transparent  hover:bg-white-500 font-normal  py-1 px-4 border border-primarygreen hover:border-green-500 rounded-full text-white ${theme === "dark" ? "hover:text-white" : "hover:text-black" }`}
            >
              Raise
            </button>}
            <button
              className="m-1 w-max bg-transparent hover:bg-green-500 text-black-700 font-normal hover:text-white py-1 px-4 border border-lightGrey hover:border-transparent rounded-full "
              onClick={() => {
                navigate(
                  `/user-dashboard/adds/createadd?Editid=${Product?._id}`
                );
              }}
            >
              Edit
            </button>
            <button
              className="m-1 w-max bg-transparent hover:bg-green-500 text-black-700 font-normal hover:text-white py-1 px-4 border border-lightGrey hover:border-transparent rounded-full "
              onClick={toggleProductStatus}
            >
              Move to {Product?.UserStatus == "Archive" ? "active" : "archive"}
            </button>
          </div>
          <div
            className={`h-fit  rounded-2xl py-4 px-4 border-2 border-light  ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
          >
            <h3
              className={`border-b-2 border-light text-center py-4 text-lightGrey font-pop ${theme == "dark" && "text-white"}`}
            >
              Seller info
            </h3>
            <div className="flex flex-col font-pop gap-4 py-4">
              <div className="flex gap-2">
                <img
                  src={User?.ProfilePhoto}
                  alt=""
                  className="w-12 h-12 rounded-full"
                />
                <div className="flex flex-col gap-0">
                  <h2
                    className={`text-lg font-medium ${theme == "dark" && "text-white"}`}
                  >
                    {User?.FirstName} {User?.LastName}
                  </h2>
                  <p
                    className={`text-lightGrey ${theme == "dark" && "text-white"}`}
                  >
                    {Product?.City} {Product?.Country}
                  </p>
                </div>
              </div>
              <p
                className={`  text-lightGrey text-sm ${theme == "dark" && "text-white"}`}
              >
                Please call for more information
              </p>
              {!profileBoosted && <div className="flex flex-row font-pop gap-2 items-center">
                <div
                  className="border-2 w-full text-center cursor-pointer border-light py-2 px-4 rounded-full"
                  onClick={() => setBoostProfileSet(true)}
                >
                  Boost My Profile
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDetail;
